import React from "react";
import { Outlet } from "react-router";
import RouteLayout from "../../Components/Layout/RouteLayout";

function ControlReview() {
  return (
    <RouteLayout title={"Control Review/"}>
      <Outlet />
    </RouteLayout>
  );
}

export default ControlReview;
